module.exports = __webpack_public_path__ + "static/media/spinner.7b7a15d6.gif";